import { useQuery } from "@tanstack/react-query";
import React from "react";
import { Navigate } from "react-router-dom";

import { getSessionToken } from "../../api/token-helper.ts";
import useUserStore from "../../stores/user.store.ts";
import { api } from "../../api/custom-api.ts";

type Props = {
  children: React.ReactNode;
};

const ProtectedRoute = ({ children }: Props) => {
  const { setUser, user } = useUserStore();

  const accessToken = getSessionToken();

  useQuery({
    queryKey: ["whoAmI"],
    queryFn: () => {
      return api.auth.getAuthWhoAmI();
    },
    onSuccess: (response) => {
      setUser(response);
    },
    enabled: !!accessToken,
  });

  if (!user) {
    return <Navigate to={"/auth"} />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
